import { BarChart, axisClasses } from "@mui/x-charts";
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axiosInstance from "../../axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import BotAdminPanel from "./customization/botAccess/BotAdminPanel";

const UserProfile = () => {
    const [userData, setUserData] = useState({
        id: 0,
        first_name: "None",
        username: "None",
        wallet: { coins: 0, premium_coins: 0 }
    });
    const [statistic, setStatistic] = useState([]);
    const tg = window.Telegram.WebApp;
    const { t } = useTranslation();

    useEffect(() => {
        const getUserInfo = async () => {
            try {
                const response = await axiosInstance.get(`/user/info`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                setUserData(response.data);
            } catch (error) {
                console.error(error);
                toast.error(t("Failed to fetch user info."));
            }
        };

        const getStatistic = async () => {
            try {
                const response = await axiosInstance.get(`/user/statistic`, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
                setStatistic(response.data);
            } catch (error) {
                console.error(error);
                toast.error(t("Failed to fetch statistic."));
            }
        };

        getUserInfo();
        getStatistic();
    }, [t]);

    return (
        <div className="w-100 m-0 d-flex flex-column">
            <div id="user-info-block" className="">
                <div className="bg-secondary p-2">
                    <div className="row m-0">
                        <div className="col-12 text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="50%" viewBox="0 0 24 24" data-name="025_SCIENCE" id="_025_SCIENCE">
                                <path className="cls-1" d="M9,15a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v2A1,1,0,0,1,9,15Z"/>
                                <path className="cls-1" d="M15,15a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v2A1,1,0,0,1,15,15Z"/>
                                <path className="cls-1" d="M6,8a1,1,0,0,1-.71-.29l-3-3A1,1,0,0,1,3.71,3.29l3,3a1,1,0,0,1,0,1.42A1,1,0,0,1,6,8Z"/><path className="cls-1" d="M18,8a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42l3-3a1,1,0,1,1,1.42,1.42l-3,3A1,1,0,0,1,18,8Z"/><path className="cls-1" d="M21,20H3a1,1,0,0,1-1-1V14.5a10,10,0,0,1,20,0V19A1,1,0,0,1,21,20ZM4,18H20V14.5a8,8,0,0,0-16,0Z"/></svg>
                        </div>
                        <div className="col-12 text-center">
                            <span className="fs-2">
                                {userData.first_name}
                            </span>
                        </div>
                        <div className="col-12 text-center">
                            <small className="hint-text">
                                {userData.username !== "" ? "@" + userData.username : "id:" + userData.id}
                            </small>
                        </div>
                    </div>
                </div>

                <div className="d-flex p-1 pb-0">
                    <div className="col-6 p-1">
                        <div className="w-100 p-1 pb-3 pt-3 bg-secondary text-center rounded-2">
                            <span className="fs-4"><small className="fs-6"> 🧩</small>{userData.wallet.coins}</span>
                        </div>
                    </div>
                    <div className="col-6 p-1">
                        <div className="w-100 p-1 pb-3 pt-3 bg-secondary text-center rounded-2">
                            <span className="fs-4"><small className="fs-6">🩸</small>{userData.wallet.premium_coins}</span>
                        </div>
                    </div>
                </div>
                <div className="d-flex p-1 pt-0">
                    <div className="col-8 p-1">
                        <div className="w-100 p-1 bg-secondary text-center rounded-2">
                            <BarChart
                                className="w-100"
                                xAxis={[
                                    {
                                        id: 'Days',
                                        data: statistic.map(entry => new Date(entry.day)),
                                        scaleType: 'band',
                                        valueFormatter: (date) => `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`,
                                    },
                                ]}
                                series={[
                                    {
                                        id: t('Messages'),
                                        label: t('Messages'),
                                        data: statistic.map(entry => entry.count),
                                        area: true,
                                        color: 'var(--tg-theme-accent-text-color)',
                                        showMark: false,
                                    },
                                ]}
                                sx={(theme) => ({
                                    [`.MuiChartsLegend-series tspan`]: {
                                        fill: "var(--tg-theme-text-color)"
                                    },
                                    [`.${axisClasses.root}`]: {
                                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                                            stroke: 'var(--tg-theme-text-color)',
                                            strokeWidth: 2,
                                        },
                                        [`.${axisClasses.tickLabel}`]: {
                                            fill: 'var(--tg-theme-text-color)',
                                        },
                                        [`${axisClasses.root}`]: {
                                            fill: 'var(--tg-theme-text-color)',
                                        },
                                    },
                                    backgroundImage: `linear-gradient(var(--tg-theme-secondary-bg-color) 1px, transparent 1px), linear-gradient(90deg, var(--tg-theme-secondary-bg-color) 1px, transparent 1px)`,
                                    backgroundSize: '35px 35px',
                                    backgroundPosition: '20px 20px, 20px 20px',
                                })}
                                height={200}
                            />
                        </div>
                    </div>
                    <div className="col-4 p-1">
                        <div className="row p-0 m-0 h-100">
                            <div className="col-12 w-100 p-1 align-content-center bg-secondary text-center rounded-2 disabled">
                                <span className="">{t("Users rate")}</span>
                            </div>
                            <div className="col-12 w-100 p-1 mb-1 mt-1 align-content-center bg-secondary text-center rounded-2 disabled">
                                <span className="">{t("Questionnaire")}</span>
                            </div>
                            <div className="col-12 w-100 p-1 align-content-center bg-secondary text-center rounded-2 disabled">
                                <span className="">{t("...")}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-block p-1 pt-0">
                    <Link to={"inv"} className="bg-secondary w-100 row m-0 mt-1 p-1 align-items-center rounded-2">
                        <div className="col-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="100%" height="100%" viewBox="0 0 512 512" data-name="Layer 1" id="Layer_1">
                                <path d="M436.38,138c-21.53-46-67.93-74.16-118-76a21.68,21.68,0,0,0-2.17-.12H213.29c-46.31,0-89.6,10-120.79,47.4-26.42,31.71-31.34,68.29-31.34,107.72V432.42A17.9,17.9,0,0,0,78.8,450.06H431.63a17.9,17.9,0,0,0,17.64-17.64V290.93C449.27,242.52,457.48,183.15,436.38,138Zm-332.8,20c18.17-44.52,60-60.76,104.72-60.76H316.2c41,.85,78.47,25.82,92.24,65.11,6.28,17.94,5.55,36.12,5.55,54.72v21.3H96.42C96.23,212,93.49,182.71,103.58,158ZM218.39,273.65H292v33H218.39ZM123.2,414.77H96.44V273.64h86.67v50.67A17.9,17.9,0,0,0,200.75,342H309.68a17.67,17.67,0,0,0,17.64-17.64V273.64H414V414.77Z"/>
                            </svg>
                        </div>
                        <div className="col-10 d-flex pb-1 bt-1 fs-6">
                            <div>
                                {t("Inventory")}
                            </div>
                        </div>
                    </Link>
                    <Link to={"mrp"} className="bg-secondary w-100 row m-0 mt-1 p-1 align-items-center rounded-2">
                        <div className="col-2">
                            <svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" version="1.1" id="_x32_" viewBox="0 0 512 512" >
                                <g>
                                    <path className="st0" d="M293.686,333.324c5.976,52.529,58.497,59.684,74.014,59.684c15.521,0,68.042-7.155,74.01-59.684   c-9.545,8.358-40.582,22.691-74.01,22.691C334.276,356.014,303.239,341.681,293.686,333.324z"/>
                                    <path className="st0" d="M312.681,272.069c12.31,1.33,23.671,5.338,33.591,11.37c0.394-17.695-12.824-33.041-30.747-34.969   c-17.827-1.92-33.926,10.126-37.423,27.344C288.894,272.189,300.622,270.778,312.681,272.069z"/>
                                    <path className="st0" d="M389.129,283.439c9.919-6.032,21.285-10.039,33.587-11.37c12.067-1.291,23.786,0.12,34.579,3.745   c-3.498-17.218-19.596-29.264-37.42-27.344C401.948,250.398,388.73,265.744,389.129,283.439z"/>
                                    <path className="st0" d="M511.724,171.919c0,0-0.02-0.216-0.036-0.327l-0.02-0.104l-0.02-0.144c-0.948-6.86-5.975-12.389-13.05-13.106   c-5.765-0.59-11.586,2.35-17.119,3.673c-11.405,2.693-22.97,4.74-34.535,6.462c-30.085,4.478-60.56,6.549-90.964,5.832   c-23.604-0.55-47.223-2.621-70.552-6.278c-8.7-36.101-23.006-95.259-27.058-112.023c-0.82-3.402-1.43-8.724-8.29-3.792   c-4.96,3.593-54.665,28.874-118.249,44.243C68.247,111.724,12.475,111.916,6.42,111c-8.346-1.275-6.466,3.744-5.641,7.146   C5.133,136.16,21.294,203.039,29.7,237.777c20.496,84.87,111.994,128.117,164.213,115.489c11.242-2.717,22.918-8.573,34.125-16.939   c11.282,46.108,43.136,86.902,84.714,109.784c13.413,7.378,28.077,12.979,43.311,15.027c14.935,2.023,29.942-0.167,44.14-5.02   c27.938-9.56,52.665-28.213,71.624-50.649c18.481-21.886,31.731-48.227,37.172-76.408c2.506-12.964,2.848-25.934,2.848-39.073   V186.977C511.848,182.029,512.262,176.842,511.724,171.919z M61.156,185.351c11.358,0.972,23.082-0.398,34.487-4.493   c11.656-4.176,21.776-10.733,29.99-18.932c4.534,17.098-4.705,35.129-21.679,41.2C87.086,209.182,68.606,201.262,61.156,185.351z    M223.564,256.612c-13.808-2.852-33.539-3.991-52.84,0.685c-28.596,6.908-52.18,25.576-58.625,34.691   c-5.744-46.156,37.694-63.134,50.98-66.354c10.202-2.47,40.001-5.832,60.485,12.629V256.612z M231.835,159.648   c-1.932,3.928-4.581,7.466-7.844,10.406c-5.008,4.526-11.405,7.633-18.6,8.581c-17.875,2.327-34.324-9.489-38.108-26.794   c11.07,3.554,23.046,4.764,35.328,3.171c12.019-1.57,23.082-5.705,32.734-11.76C235.564,149.083,234.289,154.677,231.835,159.648z    M488.574,284.937c0,12.708,0.16,25.337-2.079,37.91c-1.933,10.867-5.247,21.448-9.72,31.519c-0.056,0.104-0.112,0.231-0.164,0.358   c-0.015,0.048-0.055,0.104-0.071,0.175c-0.088,0.183-0.164,0.374-0.251,0.557c-0.159,0.374-0.339,0.749-0.518,1.14   c0.048-0.144,0.123-0.263,0.179-0.415c-11.354,24.644-29.67,46.164-51.892,61.66c-12.302,8.589-26.109,15.593-40.813,18.939   c-13.732,3.155-27.284,1.825-40.57-2.701c-27.826-9.506-52.032-29.814-69.01-53.526c-13.286-18.564-22.277-40.076-25.496-62.576   c-0.88-6.103-1.326-12.302-1.326-18.516V184.149c14.274,3.513,28.83,6.102,43.438,8.07c9.314,1.275,18.676,2.295,27.986,3.14   c31.193,2.805,62.548,2.964,93.757,0.43c25.66-2.079,51.514-5.497,76.551-11.656V284.937z"/>
                                </g>
                            </svg>
                        </div>
                        <div className="col-10 d-flex fs-6">
                            <div>
                                {t("Custom Interplay Commands")}
                            </div>
                        </div>
                    </Link>
                    <Link to={"rpe"} className="bg-secondary w-100 row m-0 mt-1 p-1 align-items-center rounded-2">
                        <div className="col-2">
                            <svg className="stroke-svg-color" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" >
                                <path d="M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z" fill="#0F0F0F"/>
                                <path d="M17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5Z" fill="#0F0F0F"/>
                                <path d="M8.88875 13.5414C8.63822 13.0559 8.0431 12.8607 7.55301 13.1058C7.05903 13.3528 6.8588 13.9535 7.10579 14.4474C7.18825 14.6118 7.29326 14.7659 7.40334 14.9127C7.58615 15.1565 7.8621 15.4704 8.25052 15.7811C9.04005 16.4127 10.2573 17.0002 12.0002 17.0002C13.7431 17.0002 14.9604 16.4127 15.7499 15.7811C16.1383 15.4704 16.4143 15.1565 16.5971 14.9127C16.7076 14.7654 16.8081 14.6113 16.8941 14.4485C17.1387 13.961 16.9352 13.3497 16.4474 13.1058C15.9573 12.8607 15.3622 13.0559 15.1117 13.5414C15.0979 13.5663 14.9097 13.892 14.5005 14.2194C14.0401 14.5877 13.2573 15.0002 12.0002 15.0002C10.7431 15.0002 9.96038 14.5877 9.49991 14.2194C9.09071 13.892 8.90255 13.5663 8.88875 13.5414Z" fill="#0F0F0F"/>
                                <path d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 20.9932C7.03321 20.9932 3.00683 16.9668 3.00683 12C3.00683 7.03321 7.03321 3.00683 12 3.00683C16.9668 3.00683 20.9932 7.03321 20.9932 12C20.9932 16.9668 16.9668 20.9932 12 20.9932Z" fill="#0F0F0F"/>
                            </svg>
                        </div>
                        <div className="col-10 d-flex fs-6">
                            <div>
                                {t("Emoji RP triggers")}
                            </div>
                        </div>
                    </Link>
                </div>
            </div>
            <div className="mt-auto">
                <BotAdminPanel/>
            </div>
        </div>
    );
};

export default UserProfile;
